// extracted by mini-css-extract-plugin
module.exports = {"tag-icons__icon":"TagIcon_tag-icons__icon__tJ3v5","tag-icons__img":"TagIcon_tag-icons__img__1bz-I"};